import { render } from "./ExportRender.vue?vue&type=template&id=38df2807&scoped=true&ts=true"
import script from "./ExportRender.vue?vue&type=script&lang=ts"
export * from "./ExportRender.vue?vue&type=script&lang=ts"

import "./ExportRender.vue?vue&type=style&index=0&id=38df2807&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38df2807"]])

export default __exports__